import { siteConfig } from '@/config/site'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import Cookies from 'js-cookie'

import { axiosInstance } from '../axios'

export function GetUser() {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const token = Cookies.get(siteConfig.tokenKey)
      if (!token) {
        return undefined
      }

      const user = await axiosInstance.get('/user')
      const { categories, authStatus, id, lastLoginAt } = user
      const categoryIds = categories
        .filter(item => item.isEnable)
        .map(category => category.id)
        .sort()
      const isAuth = authStatus === 'pass'
      const isApply = authStatus === 'processing'
      const isLogin = Number.isInteger(id) && Number.isInteger(lastLoginAt)
      const role = isLogin ? (isAuth ? 'creator' : 'user') : 'guest'
      const result = {
        ...user,
        subscribes: user.subscribes || [],
        categoryIds,
        isAuth,
        isApply,
        isLogin,
        role,
        likedVideoIds: user?.likedVideoIds || [],
        favoriteVideoIds: user?.favoriteVideoIds || [],
        favoriteChannelIds: user?.favoriteChannelIds || [],
      }
      return result
    },
    enabled: !!Cookies.get(siteConfig.tokenKey),
  })
}

export function UpdateCategory() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ categoryId }) =>
      axiosInstance.patch('/user/category', { categoryId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    },
  })
}

export function UpdateUser() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: data => axiosInstance.patch('/user', { ...data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    },
  })
}

export function ApplyIdentity() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ identityId, identityId2 }) =>
      axiosInstance.post('/user/identity', { identityId, identityId2 }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    },
  })
}

export function RequestChangePassword() {
  return useMutation({
    mutationFn: () => axiosInstance.post('/user/password/code', {}),
  })
}

export function ChangePassword() {
  return useMutation({
    mutationFn: ({ code, password, confirmPassword }) =>
      axiosInstance.patch('/user/password', {
        code,
        password,
        confirmPassword,
      }),
  })
}

export function SendVerifyPhoneCode() {
  return useMutation({
    mutationFn: ({ phone }) =>
      axiosInstance.post('/user/verifyPhone', { phone }),
  })
}

export function VerifyPhoneCode() {
  return useMutation({
    mutationFn: ({ phone, code }) =>
      axiosInstance.patch('/user/verifyPhone', { phone, code }),
  })
}

export function VerifyCreditCard() {
  return useMutation({
    mutationFn: ({ return_url }) =>
      axiosInstance.post('/user/verifyCreditCard', { return_url }),
  })
}
